
export function traverseComponents(data,process)
{
	if (!data) return;
	process(data);

	if (data.layout=='popup' || data.layout=='styles' ) 
		traverseComponents(data.content,process);

	else if (data.layout=='grid' || data.layout=='vertical')
		for (const item of data.items ?? [])
			traverseComponents(item,process);

	else if (data.layout=='slides')
		for (const slide of data.slides ?? [])
			traverseComponents(slide,process);

	else if (data.layout=='link')
		traverseComponents(data.content,process);

	else if (data.layout=='visualWithInfo') {
		traverseComponents(data.upper,process);
		traverseComponents(data.visual,process);
		traverseComponents(data.lower,process);
	}

	else if (data.layout=='overlay') {
		traverseComponents(data.foreground,process);
		traverseComponents(data.background,process);
	}
}

